import { Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MdbNotificationRef, MdbNotificationService } from 'mdb-angular-ui-kit/notification';
import { DangerToastComponent } from '../danger-toast/danger-toast.component';
import { SuccessToastComponent } from '../success-toast/success-toast.component';
import { DefaultToastComponent } from '../default-toast/default-toast.component';
import { WarningToastComponent } from '../warning-toast/warning-toast.component';
import { ToastService } from 'app/toast/services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-mdb-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToastMdbComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  notificationRef: MdbNotificationRef<ToastMdbComponent> | null = null;

  constructor(
    private notificationService: MdbNotificationService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
    this.toastService.showSubject.pipe(
     takeUntilDestroyed(this.destroyRef)
    ).subscribe((toast : any) => {
      const config = {
        position: 'top-right',
        delay: toast.delay,
        autohide: true,
        stacking: true,
        animation: true,
        data: {
          message: toast.message
        }
      };

      switch (toast.type) {
        case 'success':
          return this.openToast(SuccessToastComponent, config);
        case 'warning':
          return this.openToast(WarningToastComponent, config);
        case 'danger':
          return this.openToast(DangerToastComponent, config);
        default:
          return this.openToast(DefaultToastComponent, config);
      }
    });
  }

  openToast(component, config) {
    this.notificationRef = this.notificationService.open(component, config);
  }

}
